/** Le cadre de `<WebFrame>` et son attente, communs à la WebView du téléphone et à l'iframe du web. */
import { StyleSheet } from "react-native-unistyles"

export const webFrameStyles = StyleSheet.create((theme) => ({
    frame: (height: number) => ({
        height,
        borderRadius: theme.radius.lg,
        borderWidth: 1,
        borderColor: theme.colors.border,
        backgroundColor: theme.colors["surface-raised"],
        overflow: "hidden" as const,
    }),
    /** Par-dessus la page qui arrive, au milieu du cadre. */
    waiting: {
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.colors["surface-raised"],
    },
}))
